import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { useVueFlow } from "@vue-flow/core";
import { computed } from "vue";
import OaiTooltip from "shared/components/other/OaiTooltip.vue";
import { CriticalPathLayout, CriticalPathPosition } from "shared/types/CriticalPath";
import {
  BuildingRoofEdge,
  BuildingRoofHeight,
  LevelLabelWidth,
} from "shared/views/critical_path/criticalPathLayout";

const labelFontSize = 16;


export default /*#__PURE__*/_defineComponent({
  __name: 'CriticalPathBackground',
  props: {
    layout: {}
  },
  setup(__props: any) {

const props = __props;

const { viewport } = useVueFlow();

const buildingsWithLevels = computed(() => {
  const sharedLevelsWithBuilding = props.layout.sharedBuilding
    ? props.layout.levels
        .filter((levelPosition) => props.layout.sharedLevelIds.has(levelPosition.id))
        .map((levelPosition) => ({
          id: levelPosition.id,
          buildingPosition: props.layout.sharedBuilding as CriticalPathPosition<null, null>,
          levelPosition,
        }))
    : [];
  return [
    ...props.layout.buildings.flatMap((buildingPosition) =>
      props.layout.levels
        .filter((levelPosition) => !props.layout.sharedLevelIds.has(levelPosition.id))
        .map((levelPosition) => ({
          id: `${buildingPosition.id}_${levelPosition.id}`,
          buildingPosition,
          levelPosition,
        })),
    ),
    ...sharedLevelsWithBuilding,
  ];
});

const buildingPositionsForRectangles = computed(() => {
  return [
    ...props.layout.buildings.filter((position) => position.width > 0),
    props.layout.sharedBuilding,
  ].filter((item) => item) as CriticalPathLayout["buildings"];
});

const createTranslate = (x: number, y: number) => {
  const finalX = x * viewport.value.zoom + viewport.value.x;
  const finalY = y * viewport.value.zoom + viewport.value.y;
  return `translate(${finalX}px, ${finalY}px)`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buildingPositionsForRectangles.value, (buildingPosition) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "absolute top-0 left-0 border-gray-600 border-2",
        style: _normalizeStyle({
        width: `${buildingPosition.width * _unref(viewport).zoom}px`,
        height: `${buildingPosition.height * _unref(viewport).zoom}px`,
        transform: `${createTranslate(buildingPosition.x, buildingPosition.y)}`,
      }),
        key: buildingPosition.id || 'null'
      }, null, 4))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.buildings.filter((position) => position.id !== null), (buildingPosition) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "absolute top-0 left-0 border-gray-600 h-0",
        style: _normalizeStyle({
        width: `${buildingPosition.width * _unref(viewport).zoom}px`,
        borderBottom: `${_unref(BuildingRoofHeight) * _unref(viewport).zoom}px solid #4B5563`,
        borderLeft: `${_unref(BuildingRoofEdge) * _unref(viewport).zoom}px solid transparent`,
        borderRight: `${_unref(BuildingRoofEdge) * _unref(viewport).zoom}px solid transparent`,
        transform: `${createTranslate(
          buildingPosition.x,
          buildingPosition.y - _unref(BuildingRoofHeight) + 1,
        )}`,
      }),
        key: buildingPosition.id || 'null'
      }, null, 4))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(buildingsWithLevels.value, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["absolute top-0 left-0 border-dashed border-gray-600", index === 0 ? '' : 'border-t']),
        style: _normalizeStyle({
        width: `${item.buildingPosition.width * _unref(viewport).zoom}px`,
        transform: `${createTranslate(item.buildingPosition.x, item.levelPosition.y)}`,
      }),
        key: item.id
      }, null, 6))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.buildings.filter((p) => p.label), (position) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "absolute top-0 left-0 truncate text-center z-[100] text-white",
        style: _normalizeStyle({
        width: `${position.width * _unref(viewport).zoom}px`,
        height: `${_unref(BuildingRoofHeight) * _unref(viewport).zoom}px`,
        padding: `0 ${_unref(BuildingRoofEdge) * _unref(viewport).zoom}px`,
        lineHeight: `${_unref(BuildingRoofHeight) * _unref(viewport).zoom}px`,
        fontSize: `${labelFontSize * _unref(viewport).zoom}px`,
        transform: `${createTranslate(position.x, position.y - _unref(BuildingRoofHeight))}`,
      }),
        key: position.id || 'null'
      }, [
        _createVNode(OaiTooltip, { cls: "truncate" }, {
          tooltip: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(position.label), 1)
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(position.label) + " ", 1)
          ]),
          _: 2
        }, 1024)
      ], 4))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.levels, (position) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "absolute top-0 left-0 flex items-center px-1 z-[100]",
        style: _normalizeStyle({
        width: `${_unref(LevelLabelWidth) * _unref(viewport).zoom}px`,
        height: `${position.height * _unref(viewport).zoom}px`,
        fontSize: `${labelFontSize * _unref(viewport).zoom}px`,
        transform: `${createTranslate(position.x - _unref(LevelLabelWidth), position.y)}`,
      }),
        key: position.id
      }, [
        _createVNode(OaiTooltip, { cls: "truncate" }, {
          tooltip: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(position.label), 1)
          ]),
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(position.label) + " ", 1)
          ]),
          _: 2
        }, 1024)
      ], 4))
    }), 128))
  ]))
}
}

})